// extracted by mini-css-extract-plugin
export var button = "_ct-4";
export var hasDarkBackground = "_ct-7";
export var hasLightBackground = "_ct-6";
export var iconWrapper = "_ct-0";
export var large = "_ct-2";
export var medium = "_ct-1";
export var small = "_ct-5";
export var xsmall = "_ct-3";